export const phoneMask = '+ 1 999 999 9999';
